import styled, { keyframes, css } from 'styled-components';
import { AvatarImage } from '@custom-components';
import { mixins, colors, media, zIndex, fonts } from '../../../css';
import NavLink from '../common/NavLink';

export const MobileWrapper = styled.nav`
  display: flex;
  flex-flow: row nowrap;
  align-items: center;
  justify-items: center;
  align-content: center;
  justify-content: center;
  width: 100%;
  height: ${mixins.pxToRem(55)};
  min-width: ${mixins.pxToRem(320)};
  margin: 0 auto;
  background-color: ${colors.colorWhite};
`;

export const MenuHamburger = styled.div`
  max-width: ${mixins.pxToRem(60)};
  height: 100%;
  a.menu {
    margin: ${mixins.pxToRem(17.5)} ${mixins.pxToRem(20)};
  }
`;

export const UserButtonContainer = styled.div`
  max-width: ${mixins.pxToRem(60)};
  height: 100%;
  a.menu {
    margin: ${mixins.pxToRem(7.5)} ${mixins.pxToRem(20)} ${mixins.pxToRem(7.5)} ${mixins.pxToRem(0)};
  }
`;

export const ProfilePic = styled.div`
  width: ${mixins.pxToRem(40)};
  height: ${mixins.pxToRem(40)};
  ${media.greaterThan('lg')`height: 50%;`};
`;

export const AutoAvatar = styled(AvatarImage)`
  width: 100%;
  height: 100%;
  p {
    line-height: 1.2;
    font-size: 0.8em;
    color: ${colors.colorGrey};
  }
`;

export const UserPic = styled.div`
  width: ${mixins.pxToRem(80)};
  height: ${mixins.pxToRem(80)};
  ${media.greaterThan('lg')`height: 50%;`};
`;

export const UserAvatar = styled(AvatarImage)`
  width: 100%;
  height: 100%;
  p {
    line-height: 1.2;
    font-size: 1.8em;
    color: ${colors.colorGrey};
  }
`;

export const HomeLinkContainer = styled.div`
  height: 100%;
  flex-grow: 1;
  padding: 0 ${mixins.pxToRem(20)};
  justify-content: center;
  display: flex;
  opacity: 1;
  transition: opacity 0.4s, transform 0.4s;

  > a {
    width: ${mixins.pxToRem(100)};
    align-items: center;
  }
`;
/* Flyout Styles */

const flyIn = css`
  ${keyframes`
  0% {
    transform: translateX(-100%);
  } 
  100% {
    transform: translateX(0);
  }  
  `}
`;

const flyOut = css`
  ${keyframes`
  0% {
    transform: translateX(0);
  }  
  100% {
    transform: translateX(-100%);
  } 
  `}
`;

const flyInRight = css`
  ${keyframes`
  0% {
    transform: translateX(100%);
  } 
  100% {
    transform: translateX(0);
  }  
  `}
`;

const flyOutRight = css`
  ${keyframes`
  0% {
    transform: translateX(0);
  }  
  100% {
    transform: translateX(100%);
  } 
  `}
`;

const Flyout = styled.div`
  ${({ theme }) => `background-color: ${theme.darkTheme}`};
  position: fixed;
  top: 0;
  left: 0;
  right: ${mixins.pxToRem(20)};
  min-width: ${mixins.pxToRem(320)};
  height: 100vh;
  z-index: ${zIndex.navigation.flyout};
  transform: translateX(-100%);

  &.flyout-enter {
    transform: translateX(-100%);
  }
  &.flyout-enter-active {
    right: ${mixins.pxToRem(20)};
    animation: ${flyIn} 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }
  &.flyout-enter-done {
    right: ${mixins.pxToRem(20)};
    transform: translateX(0);
  }
  &.flyout-exit {
    right: ${mixins.pxToRem(20)};
    transform: translateX(0);
  }
  &.flyout-exit-active {
    animation: ${flyOut} 0.4s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  }
  &.flyout-exit-done {
    transform: translateX(-100%);
  }

  &.flyoutRight-enter {
    transform: translateX(-100%);
  }
  &.flyoutRight-enter-active {
    right: ${mixins.pxToRem(20)};
    animation: ${flyInRight} 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94) both;
  }
  &.flyoutRight-enter-done {
    right: ${mixins.pxToRem(20)};
    transform: translateX(0);
  }
  &.flyoutRight-exit {
    right: ${mixins.pxToRem(20)};
    transform: translateX(0);
  }
  &.flyoutRight-exit-active {
    animation: ${flyOutRight} 0.4s cubic-bezier(0.55, 0.085, 0.68, 0.53) both;
  }
  &.flyoutRight-exit-done {
    transform: translateX(-100%);
  }
`;

export const MenuFlyout = styled(Flyout)``;
export const UserFlyout = styled(Flyout)`
  right: 0;
  width: 100%;
  overflow: auto;

  a {
    &:hover {
      ${({ theme }) => `background-color: ${theme.mainTheme}`};
    }
  }
`;

export const FlyoutBar = styled.div`
  width: 100%;
  margin-bottom: ${mixins.pxToRem(15)};
  height: ${mixins.pxToRem(70)};
  display: flex;
  flex-flow: row nowrap;
  align-items: center;

  &.user {
    margin-bottom: 0;
    ${({ theme }) => `background-color: ${theme.mainTheme}`};
  }
`;

export const FlyoutContainer = styled.div`
  width: 100%;
  height: calc(100vh - ${mixins.pxToRem(85)});
  overflow-y: auto;
  overflow-x: hidden;
  padding: 0;
  display: flex;
  flex-direction: column;
  &.user {
    min-height: ${mixins.pxToRem(570)};
  }
  a {
    padding: ${mixins.pxToRem(15)} ${mixins.pxToRem(25)};
    ${({ theme }) => `color: ${theme.lightText}`};
  }
`;

/* End Flyout Styles */

export const CloseBack = styled(NavLink)`
  margin: ${mixins.pxToRem(20)} ${mixins.pxToRem(25)} 0;
  &:hover {
    ${({ theme }) => `color: ${theme.lightTheme}`};
  }
`;

export const SpacerContainer = styled.div`
  flex-grow: 1;
  display: flex;
  justify-content: flex-end;
`;

export const ContactIcon = styled(NavLink)`
  margin: ${mixins.pxToRem(20)} ${mixins.pxToRem(35)} 0;
  &:hover {
    ${({ theme }) => `color: ${theme.lightTheme}`};
  }
`;

export const Underlay = styled.div`
  width: 100%;
  height: 100vh;
  z-index: ${zIndex.navigation.underlay.over};
  background-color: #000000;
  opacity: 0.6;
  transition: opacity 0.5s, transform 0.5s;
  position: fixed;
  top: 0;
  left: 0;

  &.underlay-enter {
    opacity: 0;
  }
  &.underlay-enter-active {
    opacity: 0.7;
  }
  &.underlay-exit {
    opacity: 0.7;
  }
  &.underlay-exit-active {
    opacity: 0;
  }
`;

export const StyledSignOut = styled.div`
  ${({ theme }) => `background-color: ${theme.darkerTheme}`};
`;

export const UserPreview = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-bottom: ${mixins.pxToRem(15)};
  ${({ theme }) => `background-color: ${theme.mainTheme}`};
  padding: ${mixins.pxToRem(5)} ${mixins.pxToRem(20)} ${mixins.pxToRem(30)};
  ${({ theme }) => `color: ${theme.lightText}`};
  font-family: ${fonts.fontRegular};

  .name {
    font-size: ${mixins.pxToRem(22)};
    padding-top: ${mixins.pxToRem(20)};
    font-family: ${fonts.fontBold};
  }
  .role {
    font-size: ${mixins.pxToRem(16)};
    padding-top: ${mixins.pxToRem(10)};
    padding-bottom: ${mixins.pxToRem(30)};
  }
`;

export const PreviewNumbers = styled.div`
  display: flex;
  justify-content: space-around;
  align-items: center;
  width: 100%;
`;

export const PreviewNumber = styled.div`
  text-align: center;
  text-transform: uppercase;
  font-size: ${mixins.pxToRem(14)};
  .number {
    font-family: ${fonts.fontBold};
    font-size: ${mixins.pxToRem(22)};
    padding-bottom: ${mixins.pxToRem(5)};
  }
`;

export const StyledNavLink = styled(NavLink)`
  display: flex;
  align-items: center;
  ${({ theme }) => `color: ${theme.lightText}`};
  .label {
    margin-left: ${mixins.pxToRem(20)};
  }
  &:hover {
    ${({ theme }) => `color: ${theme.lightTheme}`};
  }
`;

export const StyledMenuLabel = styled.div`
  cursor: pointer;
  font-size: ${mixins.pxToRem(14)};
  ${({ theme }) => `color: ${theme.lightText}`};
  font-family: ${fonts.fontRegular};
  text-decoration: none;
  display: flex;
  align-items: center;
  padding: ${mixins.pxToRem(15)} ${mixins.pxToRem(25)};

  .label {
    margin-right: ${mixins.pxToRem(10)};
  }
  &:hover {
    ${({ theme }) => `background-color: ${theme.mainTheme}`};
    ${({ theme }) => `color: ${theme.lightTheme}`};
  }
`;
